import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Logo } from "@/components/site/Logo";
import { useNavLinks } from "@/components/site/Navbar";
import { groupHours } from "@/lib/hours";
import { fullAddress } from "@/lib/api";

export function Footer() {
  const { content } = useSite();
  const links = useNavLinks();
  const s = content.settings;
  const locs = content.locations;
  return (
    <footer className="relative border-t border-white/10 bg-[#070707]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-5">
          <Logo />
          <p className="h-display text-3xl text-white">2 Gyms.<br /><span className="text-gold-grad">1 Membership.</span></p>
          <a href={`https://www.instagram.com/${s.instagram}/`} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 text-sm text-white/70 transition-colors duration-200 hover:text-[var(--gold)]">
            <Instagram className="h-5 w-5" /> @{s.instagram}
          </a>
          <a href={`mailto:${s.email}`} className="flex items-center gap-2 text-sm text-white/70 hover:text-[var(--gold)]" data-testid="footer-email-link">
            <Mail className="h-4 w-4" /> {s.email}
          </a>
        </div>
        {locs.map((loc) => (
          <div key={loc.id} className="space-y-3" data-testid={`footer-location-${loc.id}`}>
            <p className="eyebrow">{loc.name}</p>
            <p className="flex gap-2 text-sm text-white/80"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[var(--gold)]" />
              <span>{fullAddress(loc)}{loc.note ? ` (${loc.note.toLowerCase()})` : ""}</span></p>
            <a href={`tel:${loc.phone_tel}`} className="flex items-center gap-2 text-sm text-white/80 hover:text-[var(--gold)]" data-testid={`footer-call-${loc.id}`}>
              <Phone className="h-4 w-4 text-[var(--gold)]" /> {loc.phone}
            </a>
            <ul className="space-y-1 pt-2 text-xs text-white/55">
              {groupHours(loc.hours).map((g) => <li key={g.days}><span className="text-white/80">{g.days}:</span> {g.label}</li>)}
            </ul>
          </div>
        ))}
        <div className="space-y-3">
          <p className="eyebrow">Explore</p>
          <ul className="grid grid-cols-2 gap-2 lg:grid-cols-1">
            {links.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-sm text-white/70 transition-colors duration-200 hover:text-white">{l.label}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 text-xs text-white/40 sm:flex-row sm:justify-between sm:px-8">
          <p>© {new Date().getFullYear()} Iron Pump Gym. Bayside & Flushing, Queens, NY.</p>
          <Link to="/admin" className="hover:text-white/70" data-testid="footer-admin-link">Staff login</Link>
        </div>
      </div>
    </footer>
  );
}
